module.exports = __webpack_public_path__ + "static/media/next-page.fe36a3a8.svg";